
import React, { useState } from 'react';
import './SubnetCalc.css';

const SubnetCalc = () => {
  const [ipCidr, setIpCidr] = useState('10.100.93.1/24');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const calculate = async () => {
    setLoading(true);
    try {
      const res = await fetch('/diagnostic-tools/subnet-calc', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ip_cidr: ipCidr })
      });
      const data = await res.json();
      if (data.status === 'success') setResult(data.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div className="tool-box premium-subnet">

      <div className="subnet-header">
        <div className="subnet-heading">
          <div className="subnet-icon">📐</div>
          <div>
            <h4>Subnet Calculator</h4>
            <p>IPv4 Network & Subnet Analysis</p>
          </div>
        </div>

        <span className="subnet-badge">
          NETWORK TOOL
        </span>
      </div>

      <div className="subnet-search">
        <label>IP ADDRESS / CIDR</label>

        <div className="input-group">
          <input
            type="text"
            className="form-control"
            value={ipCidr}
            onChange={(e) => setIpCidr(e.target.value)}
            placeholder="e.g. 10.100.93.1/24"
          />

          <button
            className="btn"
            onClick={calculate}
            disabled={loading}
          >
            {loading ? 'Calculating...' : 'Calculate'}
          </button>
        </div>

        <small>Example: 192.168.1.1/24, 10.100.93.1/24</small>
      </div>

      {result && (
        <div className="subnet-results">

          <div className="subnet-result-heading">
            <div>
              <h5>Network Analysis</h5>
              <p>Subnet calculation completed successfully</p>
            </div>
            <span className="subnet-success">● CALCULATED</span>
          </div>

          <div className="subnet-grid">

            <div className="subnet-card network-card">
              <div className="subnet-card-icon">🌐</div>
              <span>NETWORK ADDRESS</span>
              <strong>{result.network_address}</strong>
            </div>

            <div className="subnet-card mask-card">
              <div className="subnet-card-icon">🛡️</div>
              <span>SUBNET MASK</span>
              <strong>{result.netmask}</strong>
            </div>

            <div className="subnet-card broadcast-card">
              <div className="subnet-card-icon">📡</div>
              <span>BROADCAST ADDRESS</span>
              <strong>{result.broadcast_address}</strong>
            </div>

            <div className="subnet-card hosts-card">
              <div className="subnet-card-icon">💻</div>
              <span>USABLE HOSTS</span>
              <strong>{result.usable_hosts?.toLocaleString()}</strong>
              <small>Available IP Addresses</small>
            </div>

            <div className="subnet-card total-card">
              <div className="subnet-card-icon">📊</div>
              <span>TOTAL ADDRESSES</span>
              <strong>{result.total_hosts?.toLocaleString()}</strong>
              <small>Total IP Addresses</small>
            </div>

          </div>

          <div className="subnet-range-card">
            <div className="range-icon">↔</div>
            <div>
              <span>USABLE IP ADDRESS RANGE</span>
              <strong>{result.ip_range}</strong>
            </div>
          </div>

          <div className="subnet-footer">
            <span>IPV4 SUBNET ANALYSIS</span>
            <span>DIAGNOSTIC TOOLS</span>
          </div>

        </div>
      )}

    </div>
  );
};

export default SubnetCalc;